module.exports = __webpack_public_path__ + "static/brand08-1ea942ff73588eee691769287347a089.png";